import longPress from '@/helper/directives/longPress';

export default (Vue) => {
  Vue.directive('long-press', longPress);
};
